<template>
	<div>
		<b-card>
			<template #header>
				<div class="card-header-title mt-1">
					<h5>{{ $t('restaurant.product') }}</h5>
				</div>
				<div class="card-header-actions">
					<b-input-group>
						<template #append>
							<b-input-group-text><strong class="fa fa-search" /></b-input-group-text>
							<b-button @click="createForm" variant="outline-primary" size="sm" class="mr-2 ml-3"
								style="font-size: 14px"><i class="fa fa-plus-circle" /></b-button>
						</template>
						<b-form-input v-model="search" />
					</b-input-group>
				</div>
			</template>
			<b-overlay :show="loading" rounded="sm">
				<table class="table table-bordered table-hover">
					<thead>
						<tr>
							<th class="text-center">{{ '№' }}</th>
							<th class="text-center">{{ $t('restaurant.group') }}</th>
							<th class="text-center">{{ $t('goods.name') }}</th>
							<th class="text-center">{{ $t('goods.special-barcode') }}</th>
							<th class="text-center">{{ $t('goods.barcode') }}</th>
							<th class="text-center">Статус</th>
							<th class="text-center">{{ $t('goods.actions') }}</th>
						</tr>
					</thead>
					<tbody v-if="items.length > 0">
						<tr v-for="(item, index) in items" :key="`group-${index}`">
							<td class="text-center pt-3">{{ index + 1 }}</td>
							<td v-if="item.photoId" class="text-center" @click="uploadModal(item, index)"
								style="width: 10%">
								<img style="width: 70px" :src="imageUrl + item.photoId" :alt="`photos1-${index}`">
							</td>
							<td v-else class="text-center" @click="uploadModal(item, index)" style="width: 10%">
								<img style="width: 70px" src="../../assets/item.png" :alt="`photos1-${index}`">
							</td>
							<td class="text-center pt-3">{{ item.groupName }}</td>
							<td class="text-center pt-3">{{ item.name }}</td>
							<td class="text-center pt-3">{{ item.barcode }}</td>
							<td class="text-center pt-3">{{ item.multiBarcode }}</td>
							<td class="text-center pt-3"><b-checkbox v-model="item.status"
									@change="activateProduct(item)" switch />
							</td>
							<td class="text-center pt-2" style="width: 10%">
								<b-button @click="editForm(item)" variant="outline-primary" size="sm"
									class="fa fa-pencil" />
							</td>
						</tr>
					</tbody>
					<tbody v-else>
						<tr>
							<td class="text-center" colspan="9">{{ $t('empty') }}</td>
						</tr>
					</tbody>
				</table>
				<nav class="text-center mt-2">
					<b-pagination-new background :total="total" layout="prev, pager, next" :page-size="payload.limit"
						:current-page.sync="payload.page" />
				</nav>
			</b-overlay>
		</b-card>

		<!--		Image - upload		-->
		<b-modal v-model="fileUploadModal" :title="form.name" size="sm" centered hide-footer>
			<b-container>
				<b-row>
					<b-col v-if="form.photoId" class="mb-2 image-wrapper">
						<i @click.stop="deletePhoto(form)" class="fa fa-close"></i>
						<img class="img-fluid w-100 img-thumbnail mb-2" :src="imageUrl + form.photoId">
					</b-col>
					<b-col v-else>
						<div class="upload-wrapper" size="sm" variant="primary">
							<i class="fa fa-plus"></i>
							<input type="file" @input="upload">
						</div>
						<b-spinner class="ml-2" v-if="loading" small></b-spinner>
					</b-col>
				</b-row>
			</b-container>
		</b-modal>

		<!--		Create / Edit		-->
		<b-modal v-model="createModal" @close="form = {}; itemId = null"
			:title="create ? $t('incomes.create.create') : $t('booking.edit')" size="xl" centered no-close-on-backdrop
			hide-footer>
			<!-- <div>
				<img v-if="form.photoId" width="100%" :src="imageUrl + form.photoId" alt="imageForProduct">
				<img v-else width="100%" src="../../assets/item.png" alt="qwe1">
			</div> -->
			<b-input-group class="mt-3">
				<template #prepend>
					<b-input-group-text><strong>{{ $t('restaurant.group') }}</strong></b-input-group-text>
				</template>
				<b-form-select v-model="form.groupId" :options="groupList" value-field="id" text-field="name"
					@change="groupSelected" />
			</b-input-group>
			<b-input-group class="mt-3">
				<template #prepend>
					<b-input-group-text><strong>{{ $t('goods.name') }}</strong></b-input-group-text>
				</template>
				<b-form-input v-model="form.name" />
			</b-input-group>
			<b-input-group class="mt-3">
				<template #prepend>
					<b-input-group-text><strong>{{ $t('goods.special-barcode') }}</strong></b-input-group-text>
				</template>
				<b-form-input v-model="form.barcode" />
			</b-input-group>
			<b-input-group class="mt-3">
				<template #prepend>
					<b-input-group-text><strong>{{ $t('goods.barcode') }}</strong></b-input-group-text>
				</template>
				<b-form-input v-model="form.multiBarcode" />
				<template #append>
					<b-btn @click="generateBarcode" class="fa fa-refresh" />
				</template>
			</b-input-group>
			<b-input-group class="mt-3">
				<template #prepend>
					<b-input-group-text><strong>{{ $t('packageCode') }}</strong></b-input-group-text>
				</template>
				<b-form-input v-model="form.packageCode" type="number" disabled />
			</b-input-group>
			<b-input-group class="mt-3">
				<template #prepend>
					<b-input-group-text><strong>{{ $t('unitCode') }}</strong></b-input-group-text>
				</template>
				<b-form-input v-model="form.unitCode" disabled />
			</b-input-group>
			<multiselect v-model="mxikCodeId" :options="mxikList" @search-change="getMxikList($event)"
				:custom-label="mxikCustomLabel" track-by="id" :show-labels="false" :allow-empty="true"
				placeholder="mxik" class="multiselect-pricing mt-3" disabled>
				<template slot="option" slot-scope="option">
					{{ mxikCustomLabel(option.option) }}
				</template>
			</multiselect>
			<multiselect label="name" class="mt-2" track-by="id" v-model="itemId" :options="whItems" :searchable="true"
				:show-labels="false" :loading="loadingItem" @select="selectedItem" :close-on-select="true"
				:internal-search="false" @search-change="loadItems($event)" :placeholder="$t('incomes.create.product')">
				<template slot="singleLabel" slot-scope="props">
					<span>
						{{ props.option.artikul }} / {{ props.option.barcode }} / {{ props.option.name ?
							props.option.name.substring(0, 30) : '' }} / {{ props.option.unitName }}
					</span>
				</template>
				<template slot="option" slot-scope="option">
					<span>
						{{ option.option.artikul }} / {{ option.option.barcode }} / {{ option.option.name ?
							option.option.name.substring(0, 30) : '' }} / {{ option.option.unitName }}
					</span>
				</template>
			</multiselect>
			<b-row>
				<b-col>
					<table class="table table-hover table-striped table-bordered">
						<thead>
							<tr>
								<th class="text-center">№</th>
								<th class="text-center">{{ $t('goods.name') }}</th>
								<th class="text-center">{{ $t('goods.special-barcode') }}</th>
								<th class="text-center">{{ $t('goods.artikul') }}</th>
								<th class="text-center">{{ $t('incomes.create.qty') }}</th>
								<th class="text-center">{{ $t('incomes.create.price') }}</th>
								<th class="text-center">{{ $t('goods.actions') }}</th>
							</tr>
						</thead>
						<tbody>
							<tr v-for="(item, index) in form.whItems" :key="`item-${index}`">
								<td class="text-center pt-2">{{ index + 1 }}</td>
								<td class="text-center pt-2">{{ item.name }}</td>
								<td class="text-center pt-2">{{ item.barcode }}</td>
								<td class="text-center pt-2">{{ item.artikul }}</td>
								<td class="text-center" style="width: 30%">
									<b-input-group size="sm">
										<template #append>
											<b-input-group-text><strong>{{ item.unitName
											}}</strong></b-input-group-text>
										</template>
										<b-form-input v-model="item.count" />
									</b-input-group>
								</td>
								<td class="text-center" style="width: 30%">
									<b-input-group size="sm">
										<b-form-input v-model="item.afterPrice" />
									</b-input-group>
								</td>
								<td class="text-center" style="width: 6%">
									<b-button @click="deleteWhItem(index, item)" size="sm" variant="outline-danger"
										class="fa fa-trash" />
								</td>
							</tr>
						</tbody>
					</table>
				</b-col>
			</b-row>
			<hr>
			<div class="card-header-actions">
				<b-button @click="createModal = false" variant="outline-danger" class="mr-3" size="sm">{{ $t('cancel')
				}}</b-button>
				<b-button @click="save" variant="success" size="sm">{{ $t('save') }}</b-button>
			</div>
		</b-modal>
	</div>
</template>

<script>
import RestaurantGroupService from "./service/group.service";
import Multiselect from 'vue-multiselect'
import GoodsService from "../../services/goods.service";
import ProductService from "./service/product.service";
import { BOverlay } from 'bootstrapVue2';
import groupService from "./service/group.service";
import ReferencesService from "../../services/references.sevice";
import { Pagination } from 'element-ui'

export default {
	name: "product",
	components: { Multiselect, BOverlay, "b-pagination-new": Pagination },
	data() {
		return {
			items: [],
			total: 0,
			search: '',
			payload: {
				page: 1,
				limit: 20
			},
			create: true,
			createModal: false,
			form: {
				groupId: null,
				mxikCodeId: null,
				name: '',
				whItems: []
			},
			mxikCodeId: null,
			itemIndex: null,
			groupList: [],
			mxikList: [],
			categoryList: [],
			itemId: null,
			loadingItem: false,
			fileUploadModal: false,
			loading: false,
			whItems: []
		}
	},
	computed: {
		imageUrl() {
			return process.env.VUE_APP_ROOT_API + '/item/photo/'
		}
	},
	methods: {
		async groupSelected(groupId) {
			if (groupId) {
				const selectedItem = this.groupList.find(foo => foo.id === groupId)

				this.form.packageCode = selectedItem.packageCode
				this.form.unitCode = selectedItem.unitCode

				if (selectedItem.mxikCodeId) {
					await ReferencesService.getByMxikId(selectedItem.mxikCodeId).then(res => {
						this.mxikList.unshift(res.data)
						this.mxikCodeId = res.data[0]
					})
				}
			} else {
				this.mxikCodeId = null
				this.form.mxikCodeId = null
				this.form.packageCode = null
				this.form.unitCode = null
			}
		},
		async getList() {
			this.loading = true
			await ProductService.getList(this.search).then(res => {
				this.items = res.data.items
				this.total = res.data.total
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async getMxikList(keyword = '') {
			this.loading = true
			await ReferencesService.getMxikCodeList(keyword).then(res => {
				this.mxikList = res.data
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		mxikCustomLabel(mxik) {
			return (
				mxik.mxikCode +
				" / " +
				mxik.mxikNameRu +
				" / " +
				mxik.classNameRu +
				" / " +
				mxik.groupNameRu +
				" / " +
				mxik.positionNameRu
			);
		},
		async loadItems(search) {
			this.loading = true
			await GoodsService.fetchGoodsWithKeyword(search).then(res => {
				this.whItems = res.data
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		uploadModal(item, index) {
			this.form = Object.assign({}, item)
			this.itemIndex = index
			this.fileUploadModal = true
		},
		async upload($event) {
			this.loading = true;
			const fileList = $event.target.files;
			const file = fileList[0];
			const form = new FormData();
			form.append('itemId', this.form.id);
			form.append('upload', file, file.name);
			await ProductService.setImageProduct(this.form.id, form).then(res => {
				this.fileUploadModal = false
				this.loading = false;
				this.getList();
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async deletePhoto(item) {
			await ProductService.deletePhotoProduct(item.id, item.photoId).then(res => {
				this.items[this.itemIndex].photoId = null;
				this.form.photoId = null;
			}).catch(e => {
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		createForm() {
			this.create = true
			this.itemId = null
			this.form = {}
			this.form.whItems = []
			this.form.groupId = null
			this.form.mxikCodeId = null
			this.mxikCodeId = null
			this.form.photoId = null
			this.form.status = true
			this.form.name = ''
			this.form.barcode = ''
			this.form.unitCode = ''
			this.form.packageCode = ''
			this.form.multiBarcode = ''
			this.createModal = true
		},
		async editForm(item) {
			this.create = false
			this.form = Object.assign({}, item)
			if (item.mxikCodeId) {
				await ReferencesService.getByMxikId(item.mxikCodeId).then(res => {
					this.mxikList.unshift(res.data)
					this.mxikCodeId = res.data[0]
				})
			} else {
				this.form.mxikCodeId = null
				this.mxikCodeId = null
			}
			this.createModal = true
		},
		selectedItem(item) {
			if (this.form.whItems.length > 0) {
				let boolean = false,
					index = null,
					temp = {}
				this.form.whItems.forEach((tmp, i) => {
					if (tmp.id == item.id) {
						boolean = true
						index = i
						temp = tmp
					}
				})
				if (boolean) {
					this.form.whItems.splice(index, 1)
					this.form.whItems.unshift(temp)
				} else {
					this.form.whItems.unshift(item)
				}
			} else {
				this.form.whItems.unshift(item)
			}
			this.itemId = null
		},
		deleteWhItem(index, item) {
			item.count = null
			this.form.whItems.splice(index, 1)
		},
		async generateBarcode() {
			this.loading = true
			await ProductService.generateBarcode().then(res => {
				this.form.multiBarcode = res.data
				this.loading = false
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async activateProduct(item) {
			this.loading = true
			item.status = !item.status
			await ProductService.activeOrInactive(item).then(res => {
				this.$vs.notify({
					title: 'Success',
					color: 'success',
					icon: 'close',
					position: 'top-right'
				})
				this.loading = false
				this.getList();
			}).catch(e => {
				this.loading = false
				this.$vs.notify({
					title: e.message,
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			})
		},
		async save() {
			if (this.form.groupId && this.mxikCodeId && this.form.name && this.form.whItems && this.form.whItems.length > 0 && this.form.barcode !== '' && this.form.multiBarcode !== '') {
				this.loading = true
				if (this.create) {
					let obj = {
						name: this.form.name,
						groupId: this.form.groupId,
						barcode: this.form.barcode,
						status: this.form.status,
						unitCode: this.form.unitCode,
						packageCode: this.form.packageCode,
						multiBarcode: this.form.multiBarcode,
						mxikCodeId: this.mxikCodeId.id
					}
					obj.whItems = []
					this.form.whItems.forEach(t => {
						let tmp = {
							itemId: t.id,
							count: t.count,
							afterPrice: t.afterPrice,
						}
						obj.whItems.push(tmp)
					})
					await ProductService.createProduct(obj).then(res => {
						if (!res.data.id) {
							this.$vs.notify({
								title: `Продукт уже существует с таким спецкодом ${res.data.barcode}`,
								color: 'success',
								icon: 'close',
								position: 'top-right'
							});
						} else {
							this.form = {}
							this.itemId = null
							this.createModal = false
							this.getList();
							this.$vs.notify({
								title: 'Успешно сохранено',
								color: 'success',
								icon: 'close',
								position: 'top-right'
							});
						}
					}).catch(e => {
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				} else {
					this.form.whItems.forEach(t => {
						t.xyProductId = this.form.id
						t.restaurantProductId = this.form.id
						if (!t.itemId)
							t.itemId = t.id
					})
					await ProductService.updateProduct(this.form).then(res => {
						this.form = {}
						this.itemId = null
						this.createModal = false
						this.getList();
						this.$vs.notify({
							title: 'Успешно сохранено',
							color: 'success',
							icon: 'close',
							position: 'top-right'
						});
					}).catch(e => {
						this.$vs.notify({
							title: e.message,
							color: 'danger',
							icon: 'close',
							position: 'top-right'
						});
					})
				}
				this.loading = false
			} else {
				this.$vs.notify({
					title: 'Заполните все обязательные поля',
					color: 'danger',
					icon: 'close',
					position: 'top-right'
				});
			}
		}
	},
	watch: {
		'search': {
			handler(e) {
				this.getList();
			}
		},
		'payload.page': {
			handler(e) {
				this.getList();
			}
		}
	},
	async created() {
		this.loading = true
		await this.getList();
		await this.loadItems('');
		await RestaurantGroupService.listGroup('').then(res => {
			this.groupList = res.data.items
		}).catch(e => {
			this.$vs.notify({
				title: e.message,
				color: 'danger',
				icon: 'close',
				position: 'top-right'
			});
		})
		this.loading = false
	}
}
</script>

<style scoped lang="scss">
.upload-wrapper {
	position: relative;
	overflow: hidden;
	border: 2px solid #e1e1e1;
	height: 200px;
	text-align: center;
}

.upload-wrapper i.fa {
	position: absolute;
	color: #e1e1e1;
	font-size: 50px;
	left: calc(50% - 25px);
	top: calc(50% - 25px)
}

.upload-wrapper input {
	position: absolute;
	left: 0;
	right: 0;
	top: 0;
	bottom: 0;
	opacity: 0;
}

.image-wrapper {
	position: relative;
	cursor: pointer;
}

.image-wrapper i.fa {
	position: absolute;
	right: 15px;
	color: #fff;
	top: 0;
	padding: 5px;
	border: 5px solid #08772f;
	background: #4dbd74;

	&.fa-close {
		border: .5px solid red;
		background: lightcoral;
	}
}
</style>
